module.exports = __webpack_public_path__ + "dingbeauty/admin/img/ga_5.b90bbf5f.jpg";